import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import enTranslations from '../i18n/en.json';
import seTranslations from '../i18n/se.json';

type AmazonFinanceLanguage = 'en' | 'se';

@Injectable()
export class AmazonFinanceTranslationsService {
  private readonly translations: Record<AmazonFinanceLanguage, Record<string, string>> = {
    en: enTranslations,
    se: seTranslations
  };

  constructor(private readonly translate: TranslateService) {}

  register(): void {
    this.mergeTranslations(this.translate.currentLang);
    this.translate.onLangChange.subscribe(event => this.mergeTranslations(event.lang));
  }

  private mergeTranslations(lang: string): void {
    const sharedTranslations = this.translations[lang as AmazonFinanceLanguage];
    if (!sharedTranslations) return;

    this.translate.setTranslation(lang, sharedTranslations, true);
  }
}
